module.exports = __webpack_public_path__ + "static/media/6.ef9f391a.jpg";